import { IonInput, IonSpinner } from '@ionic/react';
import { AxiosResponse } from 'axios';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';


import { BUTTON_VARIABLES } from '../../constants/ButtonVariables';
import { NumericFormat } from 'react-number-format';
import { RootState } from '../../models/RootState';
import './ExchBetSlip.scss';
import { Button, IconButton } from '@mui/material';
import { toast } from 'react-toastify';
import { Add, Close, Remove } from '@mui/icons-material';
import { clearExchangeBets, exchangeBetOddsChange, removeExchangeBet, setBettingInprogress, setExchangeBetStake } from '../../store/exchBetSlip/exchBetSlipReducer';
import { BsData } from '../../models/ExchBetSlip';
import { EventData } from '../../models/EventData';
import store from '../../store/store';
import SAP_API from '../../services/sap';
import { fetchEventInfo } from '../../store/exchangeSports/exchangeSportsAction';
import { fetchOpenBets } from '../../store/exchBetSlip/exchBetSlipAction';
import { getUserBalance } from '../../store/authActions';
type StoreProps = {
  balance: number;
  exposure: number;
  bets: BsData[];
  exchangeBetOddsChange: (index: number, odds: number) => void;
  removeExchangeBet: (index: number) => void;
  fetchEventInfo: (sportId: any, eventId: any, navigate: Function) => void;
  setExchangeBetStake: (
    index: number,
    amount: number,
    type: 'ADD' | 'SET'
  ) => void;
  eventData: EventData;
  clearExchangeBets: () => void;
  fetchOpenBets: (eventId: string, sportId: string) => void;
  bettingInprogress: boolean;
  setBettingInprogress: (val: boolean) => void;
  mobileView?: boolean;
  wallets: any;
  activeWallet: any;
  getUserBalance: () => void;
};

const ExchBetslip: React.FC<StoreProps> = (props) => {
  const {
    balance,
    exposure,
    bets,
    eventData,
    exchangeBetOddsChange,
    removeExchangeBet,
    setExchangeBetStake,
    fetchEventInfo,
    clearExchangeBets,
    fetchOpenBets,
    bettingInprogress,
    setBettingInprogress,
    wallets,
    activeWallet,
    getUserBalance
  } = props;

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const betPlaceHandler = async () => {
    let data = bets[0]
    if (data.stakeAmount < 1) {
      toast.error("Minimum stake amount required.")
      return false;
    }

    if (
      (data?.minLimit !== 0 && data?.minLimit > data.stakeAmount) ||
      (data?.maxLimit !== 0 && data?.maxLimit < data.stakeAmount)
    ) {
      toast.error("Total stake should not be less than " + data?.minLimit + " and should not exceed " + data?.maxLimit);
      return false;
    }

    if (!data.oddValue) {
      toast.error("Invalid odds")
      return false;
    }

    try {
      setLoading(true);
      setBettingInprogress(true);
      const exchData = store.getState().userDetails.exchData;

      const payload = {
        token: exchData?.token,
        partnerId: exchData?.partnerId,
        operatorId: exchData?.operatorId,
        providerId: data.provider,
        sportId: data.sportId,
        competitionId: data.competitionId,
        eventId: data.eventId,
        betType: data.betType,
        oddValue: data.oddValue,
        stakeAmount: data?.stakeAmount,
        marketType: data.marketType,
        marketName: data.marketName,
        marketId: data.marketId,
        runnerId: data.runnerId,
        runnerName: data.runnerName,
        sessionOutcome: data.sessionOutcome ? data.sessionOutcome : null,
        origin: "EXCHANGE"
      };

      const res: any = await SAP_API.post("/core/sportsbet", payload);
      if (res.data.status === "") {
        setLoading(false);
        setBettingInprogress(false);
        if (res?.data?.errorDescription?.toLocaleLowerCase()?.includes("market is expired")) {
          fetchEventInfo(payload.sportId, payload.eventId, navigate)
        }
        toast.error(res.data?.errorDescription);
        return false;
      } else if (res.data.status === "RS_OK") {
        if (res.data.betId && !res.data.errorDescription) {
          return getBetStatus(data);
        } else {
          setLoading(false);
          setBettingInprogress(false);
          toast.success(res.data?.errorDescription);
          return true;
        }
      }
    } catch (e) {
      setLoading(false);
      setBettingInprogress(false);
      toast.error("Something went wrong, try again");
      return false;
    }

  };

  const onChangeOddHandler = (
    index: any,
    data: BsData,
    control: number
  ) => {
    if (data.oddValue === 1) {
      return false;
    }

    let value;
    if (control === 1) {
      let inc;
      if (data.oddValue < 2) inc = 0.01;
      else if (data.oddValue >= 2 && data.oddValue < 3) inc = 0.02;
      else if (data.oddValue >= 3 && data.oddValue < 4) inc = 0.05;
      else if (data.oddValue >= 4 && data.oddValue < 6) inc = 0.1;
      else if (data.oddValue >= 6 && data.oddValue < 10) inc = 0.2;
      else if (data.oddValue >= 10 && data.oddValue < 20) inc = 0.5;
      else if (data.oddValue >= 20 && data.oddValue < 30) inc = 1;
      else if (data.oddValue >= 30 && data.oddValue < 50) inc = 2;
      else if (data.oddValue >= 50 && data.oddValue < 100) inc = 5;
      else if (data.oddValue >= 100 && data.oddValue < 1000) inc = 10;
      else inc = 10;
      value =
        data.marketType !== 'FANCY'
          ? (data.oddValue + inc).toFixed(2)
          : data.oddValue.toFixed(2);
    } else {
      let inc;
      if (data.oddValue <= 2) inc = 0.01;
      else if (data.oddValue > 2 && data.oddValue <= 3) inc = 0.02;
      else if (data.oddValue > 3 && data.oddValue <= 4) inc = 0.05;
      else if (data.oddValue > 4 && data.oddValue <= 6) inc = 0.1;
      else if (data.oddValue > 6 && data.oddValue <= 10) inc = 0.2;
      else if (data.oddValue > 10 && data.oddValue <= 20) inc = 0.5;
      else if (data.oddValue > 20 && data.oddValue <= 30) inc = 1;
      else if (data.oddValue > 30 && data.oddValue <= 50) inc = 2;
      else if (data.oddValue > 50 && data.oddValue <= 100) inc = 5;
      else if (data.oddValue > 100 && data.oddValue <= 1000) inc = 10;
      else inc = 10;
      value =
        data.marketType !== 'FANCY'
          ? (data.oddValue - inc).toFixed(2)
          : data.oddValue.toFixed(2);
    }

    exchangeBetOddsChange(index, parseFloat(value.toString()));
  };

  const allInStake = (index: number) => {
    let amount = 0;
    const matchingWallet = wallets.find(
      (wallet: any) => wallet?.walletName === "POINTS"
    );
    if (matchingWallet) {
      amount = Math.floor(matchingWallet?.balance - matchingWallet?.exposure);
    }
    setExchangeBetStake(index, amount, 'SET');
  }

  const getBetStatus = async (data: BsData) => {
    setLoading(true);
    setBettingInprogress(true);
    const exchData = store.getState().userDetails.exchData;
    const payload = {
      eventId: data.eventId,
      partnerId: exchData?.partnerId,
      operatorId: exchData?.operatorId,
      providerId: exchData?.providerId,
      sportId: data.sportId,
      token: exchData?.token,
    };

    while (1) {
      const res: any = await SAP_API.post("/core/userbet-status", payload);
      if (["BETTING_IN_PROGRESS", "PENDING"].includes(res.data.betStatus)) {
        continue;
      } else if (res.data.betErrorMsg.toLocaleLowerCase().includes("market is expired")) {
        fetchEventInfo(payload.sportId, payload.eventId, navigate)
        clearExchangeBets();
      } else if (
        res.data.status === "RS_OK" &&
        ["CANCELLED", "EXPIRED", "FAILED"].includes(res.data.betStatus)
      ) {
        setLoading(false);
        setBettingInprogress(false);
        toast.error(
          res.data.betErrorMsg
            ? res.data.betErrorMsg
            : "Bet is not placed, try again");
        return false;
      } else if (res.data?.betStatus === "COMPLETED") {
        setLoading(false);
        setBettingInprogress(false);
        clearExchangeBets();
        getUserBalance();
        fetchOpenBets(eventData?.eventId, eventData?.sportId);

        toast.success(
          res.data.errorDescription
            ? res.data.errorDescription
            : "Bet placed successfully.");
        return true;
      }
    }
  };

  return (
    <div className="exch-betslip-ctn">
      {bettingInprogress ? (
        <div className="betslip-progress">
          {loading ? (
            <div className="centered">
              <div className="spinner loading"></div>
            </div>
          ) : null}
        </div>
      ) : null}

      {bets && bets.length > 0
        ? bets.map((data, index) => (
          <div
            className={
              data.betType === 'BACK'
                ? 'body-ctn bs-back-bet bet-body-back  back-line'
                : 'body-ctn bet-body-lay bs-lay-bet  lay-line'
            }
          >
            <div
              key={index}
              className={
                data.betType === 'BACK'
                  ? 'bet-body bet-body-back'
                  : 'bet-body bet-body-lay'
              }
            >
              <div className="header-row">
                <div className="header-event-market-div">
                  <div className="event">{data.eventName}</div>
                  <div className="market">
                    {data.marketType === 'MATCH_ODDS' ? (
                      <>
                        {data.marketName} @{' '}
                        <span className="odd-value">{data.runnerName}</span>
                      </>
                    ) : data?.marketType === 'FANCY' ? (
                      <>
                        {data?.marketName} {data?.sessionOutcome}
                      </>
                    ) : (
                      <>
                        {data.sessionOutcome} @{' '}
                        <span className="odd-value">
                          {data.oddValue}
                        </span>
                      </>
                    )}
                  </div>
                </div>

                <IconButton
                  aria-label="close"
                  className="bet-del-btn"
                  disabled={bettingInprogress}
                  onClick={() => removeExchangeBet(index)}
                >
                  <Close className="close-icon" />
                </IconButton>
              </div>
              <div
                className={
                  data.betType === 'BACK'
                    ? 'bet-card bet-card-back'
                    : 'bet-card'
                }
              >
                <div className="input-row">
                  <div className="input-row-ctn odds-ctn">
                    <div className="row-header">
                      {"Odd Value"}
                    </div>
                    <div className="row-input">
                      <Button
                        variant="contained"
                        color="primary"
                        className="odds-btns"
                        startIcon={<Remove />}
                        onClick={() => onChangeOddHandler(index, data, 0)}
                        disabled={
                          bettingInprogress || data.marketType !== 'MATCH_ODDS'
                        }
                      ></Button>
                      <IonInput
                        type="number"
                        value={data.oddValue
                        }
                        min="1"
                        mode="md"
                        step="0"
                        debounce={500}
                        disabled={
                          bettingInprogress || data.marketType !== 'MATCH_ODDS'
                        }
                        onIonChange={(e) =>
                          exchangeBetOddsChange(
                            index,
                            parseFloat(e.detail.value ?? "0")
                          )
                        }
                      ></IonInput>

                      <Button
                        variant="contained"
                        color="primary"
                        className="odds-btns"
                        startIcon={<Add />}
                        onClick={() => onChangeOddHandler(index, data, 1)}
                        disabled={
                          bettingInprogress || data.marketType !== 'MATCH_ODDS'
                        }
                      ></Button>
                    </div>
                  </div>
                  <div className="input-row-ctn stake-ctn">
                    <div className="row-header">{"Amount"}</div>
                    <div className="bg-[var(--ion-background-color)] rounded-full">
                      <NumericFormat
                        value={data.stakeAmount}
                        thousandSeparator={true}
                        thousandsGroupStyle="lakh"
                        className="row-input"
                        allowNegative={false}
                        disabled={bettingInprogress}
                        onValueChange={(val: any) => {
                          setExchangeBetStake(index, val.floatValue, 'SET');
                        }}
                        style={{
                          height: '39px',
                          border: 0,
                          padding: '10px',
                          // maxWidth: '100px',
                        }}
                      />
                      <div className="clear-row">
                        <span
                          className={
                            bettingInprogress
                              ? 'disabled text b-text'
                              : 'text b-text'
                          }
                          onClick={() => {
                            if (!bettingInprogress) {
                              setExchangeBetStake(index, 0, 'SET');
                            }
                          }}
                        >
                          {"Clear"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="quick-bet">
                  {BUTTON_VARIABLES.map((bV, idx) => (
                    <Button
                      key={'qb-btn' + idx}
                      className="qb-btn"
                      disabled={bettingInprogress}
                      onClick={() =>
                        setExchangeBetStake(index, bV.stake, 'ADD')
                      }
                    >
                      +{bV.label}
                    </Button>
                  ))}

                  {data.marketType !== 'PREMIUM' && (
                    <>
                      <Button
                        key={'qb-btn-' + index}
                        className="qb-btn-allin"
                        disabled={bettingInprogress}
                        onClick={() =>
                          allInStake(index)
                        }
                      >
                        {"All IN"}
                      </Button>
                      <Button
                        key={'qb-btn--' + index}
                        className="qb-btn-allin"
                        disabled={bettingInprogress}
                        onClick={() =>
                          setExchangeBetStake(index, data.maxLimit, 'SET')
                        }
                      >
                        {"MAX"}
                      </Button>
                    </>
                  )}
                </div>
                <div className="d-flex-row">
                  <div className="width-mob-100">
                    <div className="profit-loss">
                      <div className="info">
                        {"Your profit/loss as per placed bet"}
                      </div>
                      <div className="returns">
                        <div className="amt">
                          {data.marketType === 'MATCH_ODDS'
                            ? data.betType === 'BACK'
                              ? (data.stakeAmount * (data.oddValue - 1)).toFixed(2)
                              : data.stakeAmount.toFixed(2)
                            : data.marketType === 'BOOKMAKER'
                              ? data.betType === 'BACK'
                                ? (
                                  data.stakeAmount *
                                  ((data.oddValue + 100) / 100 - 1)
                                ).toFixed(2)
                                : data.stakeAmount.toFixed(2)
                              : data.marketType === 'PREMIUM'
                                ? (data.stakeAmount * (data.oddValue - 1)).toFixed(
                                  2
                                )
                                : data.betType === 'BACK'
                                  ? (
                                    data.stakeAmount *
                                    ((data.oddValue + 100) / 100 - 1)
                                  ) //size
                                    .toFixed(2)
                                  : data.stakeAmount.toFixed(2)}
                        </div>
                      </div>
                    </div>

                    {/* <div className="profit-loss-pts">
                      <div className="info">
                        <div className="profit-loss">
                          <div className="info">
                            {"Total Amount (in PTS)"}
                          </div>
                        </div>
                      </div>
                      <div className="returns">
                        <div className="amt">
                          {bets.reduce((a, v) => a + v.stakeAmount, 0).toFixed(2)}
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="place-section mob-view">
                    <Button
                      className="place-btn"
                      disabled={bettingInprogress}
                      onClick={betPlaceHandler}
                    >
                      <div className="btn-content">
                        <div className="label">
                          {"Place Bet"}
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
        : null}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.exchBetSlip.bets,
    bettingInprogress: state.exchBetSlip.bettingInprogress,
    eventData: state.exchangeSports.eventInfo,
    wallets: state.userDetails?.wallets,
    activeWallet: state.userDetails?.activeWallet,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    exchangeBetOddsChange: (index: number, odds: number) =>
      dispatch(exchangeBetOddsChange({ index, odds })),
    fetchEventInfo: (sportId: string, eventId: string, navigate: Function) => dispatch(fetchEventInfo(sportId, eventId, navigate)),
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
    setExchangeBetStake: (index: number, amount: number, type: 'ADD' | 'SET') =>
      dispatch(setExchangeBetStake({ index, amount, type })),
    clearExchangeBets: () => dispatch(clearExchangeBets({})),
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    getUserBalance: () => dispatch(getUserBalance()),
    setBettingInprogress: (val: boolean) => dispatch(setBettingInprogress(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchBetslip);